export default __webpack_public_path__ + "static/media/cryptojs_v3.1.2.js.80be8a95.ld";